import * as React from 'react';
export const umpquaSvg = React.forwardRef(function umpquaSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0E231C',
      d: 'M0 .097h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm16.113 22.18-2.506-.065.533-4.68-4.156 2.486 3.315-6.47-3.897 2.274 4.625-6.97-2.846.855 4.673-4.373 4.383 4.76-3.881-.774 5.126 5.228-5.433-1.178 5.126 5.244-5.87-1.259.808 4.922ZM6.62 26.472l-.566-.985L9.5 23.68l3.865 1.372 2.684-1.372 2.75 1.307 3.687-1.63 3.493 1.63-.501 1-3.186-1.193-3.25 1.807-2.992-1.372-3.057 1.678-3.38-1.79-2.992 1.355Z',
      fill: '#fff',
    }),
  );
});
umpquaSvg.defaultProps = {
  width: '32',
  height: '33',
  viewBox: '0 0 32 33',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var umpqua = {
  category: 'brand',
  colorable: false,
  name: 'umpqua',
  svg: umpquaSvg,
};
